window.addEventListener('load', () => {
    let sections = Array.from(document.querySelectorAll('.waalem_image_with_content'))
    sections.forEach(section => {
        let big_image = section.querySelector('.waalem_image_with_content_image_desktop img')
        let thumbnails = Array.from(section.querySelectorAll('.waalem_image_with_content_thumbnails img'))
        thumbnails.forEach(thumbnail => {
            thumbnail.addEventListener('click', () => {
                big_image.src = thumbnail.src.replace('&width=160', '&width=11000')
                big_image.srcset = `${big_image.src}`
                thumbnails.forEach(thumbnail_ => {
                    if(thumbnail_ == thumbnail){
                        thumbnail_.classList.add('thumbnail_active')
                    }else{
                        thumbnail_.classList.remove('thumbnail_active')
                    }
                })
            })
        })
    })
})